import { activeShop, getActiveBrandShops, getActiveType, getBrand } from '../../auth/selectors';
import { SHOP_TYPE } from '../../main/shops/constants';
import { canUseCommissionReporting, canUserViewPayoutReport } from './users';

// eslint-disable-next-line import/prefer-default-export
export const canViewCommissionPayoutReport = (
  state
) => {
  const user = state.auth.user;
  const shop = activeShop(state);
  const brand = getBrand(state);
  const activeType = getActiveType(state);
  const activeBrandShops = getActiveBrandShops(state);
  const canUseCommissionReports = canUseCommissionReporting(state);

  const brandHasRentalShops = activeBrandShops
    && activeBrandShops.some(({ kind }) => parseInt(kind, 10) === SHOP_TYPE.rental);

  const moreThanOneShopInBrand = brand && brand.shopCount > 1;
  const brandHasCommissionOtpShops = activeBrandShops && activeBrandShops.some(
    ({ kind, commissionSplits }) => parseInt(kind, 10) === SHOP_TYPE.commission && !!commissionSplits
  );

  const showBrandPayoutReport = activeType === 'brand' && (
    !brandHasRentalShops && !(moreThanOneShopInBrand && brandHasCommissionOtpShops)
  );

  return canUseCommissionReports && (canUserViewPayoutReport(user, shop) || showBrandPayoutReport);
};
